import SortableTableHeadCell from "../../../../domains/BasicTable/SortableTableHeadCell";


export const COLUMNS: Array<SortableTableHeadCell> = [

  {
    label: "Id",
    id: "id",
    numeric: false,
    disablePadding: false,
    width: 300
  }, 
  {
    label: "Country",
    id: "country",
    numeric: false,
    disablePadding: false,
    width: 300,
  }, 
  {
    label: "Port",
    id: "port",
    numeric: false,
    disablePadding: false,
    width: "200",
  },
  {
    label: "Vessel",
    id: "vessel",
    numeric: false,
    disablePadding: false,
    width: "200"
  },
  {
    label: "Deal",
    id: "deal",
    numeric: true,
    disablePadding: false,
    width: "200"
  },
  {
    label: "System",
    id: "system",
    numeric: false,
    disablePadding: false,
    width: "200"
  },
  {
    label: "Category",
    id: "category",
    numeric: false,
    disablePadding: false,
    width: 200
  },
  {
    label: "User",
    id: "user",
    numeric: false,
    disablePadding: false,
    width: 350
  }, 
  {
    label: "Deadline or ETA",
    id: "deadline",
    numeric: false,
    disablePadding: false,
    width: 300
  }
];

export const DEFAULT_PAGE_INDEX = 0;
export const DEFAULT_PAGE_SIZE = 10;
